import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ShareButton } from "@/components/ShareButton";
import { inviteUrl, inviteMessage } from "@/lib/share";

// Loads the current creator's invite link and renders a Share control that
// shares "Join my creator network on Nearfluence …" via native share / WhatsApp /
// Email / Copy link.
export function InviteCreatorButton({ label = "Invite a Creator", variant = "default", className = "bg-emerald-600 hover:bg-emerald-700 text-white", testid = "invite-creator-share" }) {
  const [code, setCode] = useState(null);

  useEffect(() => {
    api.get("/invites/me").then((r) => setCode(r.data.code)).catch(() => {});
  }, []);

  if (!code) {
    return null;
  }
  const url = inviteUrl(code);
  return (
    <ShareButton
      url={url}
      title="Join me on Nearfluence"
      text={inviteMessage(url)}
      subject="Join my creator network on Nearfluence"
      label={label}
      variant={variant}
      className={className}
      testid={testid}
    />
  );
}
